import { render, staticRenderFns } from "./account-form.vue?vue&type=template&id=6f2e3c9f&scoped=true"
import script from "./account-form.vue?vue&type=script&lang=js"
export * from "./account-form.vue?vue&type=script&lang=js"
import style0 from "./account-form.vue?vue&type=style&index=0&id=6f2e3c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e3c9f",
  null
  
)

export default component.exports